export default "__VITE_ASSET__DS684zpJ__"